'use strict';

/**
 * Returns the lazily injected PDP enquiry modal element.
 *
 * @returns {jQuery} The enquiry modal wrapper.
 */
function getProductEnquireFormModal() {
    return $('#productenquireform');
}

/**
 * Returns the enquiry success modal element.
 *
 * @returns {jQuery} The success modal wrapper.
 */
function getCustomerSubmitResponseModal() {
    return $('#customersubmitresponse');
}

/**
 * Returns the already-enquired modal element.
 *
 * @returns {jQuery} The duplicate-enquiry modal wrapper.
 */
function getAllReadyHaveResponseModal() {
    return $('#allreadyhaveresponse');
}

/**
 * Returns the lazily injected PDP enquiry form element.
 *
 * @returns {jQuery} The enquiry form.
 */
function getEnquireForm() {
    return $('#pdp-enquire-form');
}

/**
 * Marks the customer title dropdown section in the enquiry form as invalid.
 */
function addInvalidToTitle() {
    getEnquireForm().find('.enquireform-customer-title-wrapper .custom-drop-down-section').addClass('is-invalid');
}

/**
 * Removes the validation error styling from the customer title dropdown section.
 */
function removeInvalidFromTitle() {
    getEnquireForm().find('.enquireform-customer-title-wrapper .custom-drop-down-section').removeClass('is-invalid');
}

/**
 * Toggles the invalid state for an enquiry input based on whether it has a value.
 * @param {jQuery} $input input to validate
 * @returns {boolean} whether the input has a value
 */
function validateRequiredEnquireInput($input) {
    var hasValue = $input.val().trim() !== '';
    $input.toggleClass('is-invalid', !hasValue);
    return hasValue;
}

/**
 * Validates the PDP enquire mobile input and toggles the dropdown error state.
 *
 * @returns {boolean} true when the mobile number is valid.
 */
function validatePdpMobileInput() {
    var $form = getEnquireForm();
    var $mobileInput = $form.find('.input-mobile');

    if (!$mobileInput.length) {
        return false;
    }

    var numericValue = $mobileInput.val().replace(/\D/g, '');
    var selectedCode = $form.find('#select-country-code').text();
    var maxLength = $('.pdp-enquiry-form-input.input-mobile').attr('maxlength');
    var hasTenDigits = numericValue.length === parseInt(maxLength, 10);
    var hasValidStart = selectedCode !== '+91' || !/^[0-5]/.test(numericValue);
    var isValid = hasTenDigits && hasValidStart;

    if (isValid) {
        $mobileInput.removeClass('is-invalid');
        $form.find('.enquire-customer-phone .custom-drop-down-section').removeClass('is-invalid');
    } else {
        $mobileInput.addClass('is-invalid');
        $form.find('.enquire-customer-phone .custom-drop-down-section').addClass('is-invalid');
    }

    return isValid;
}

/**
 * Validates all required PDP enquiry fields before submit.
 * @returns {boolean} whether the form is valid
 */
function validateEnquireForm() {
    var $form = getEnquireForm();
    var isValid = true;

    if (!$form.length) {
        return false;
    }

    if (!validateRequiredEnquireInput($form.find('.first-name-input'))) {
        addInvalidToTitle();
        isValid = false;
    } else {
        removeInvalidFromTitle();
    }

    if (!validateRequiredEnquireInput($form.find('.last-name-input'))) {
        isValid = false;
    }

    if (!validateRequiredEnquireInput($form.find('.input-message'))) {
        isValid = false;
    }

    if (!validatePdpMobileInput()) {
        isValid = false;
    }

    return isValid;
}

/**
 * Resets the customer title dropdown to a given title or defaults to the first option.
 *
 * @param {string} [customerTitle] - Customer title to be selected.
 */
function resetCustomerTitle(customerTitle) {
    var enquireFormCustomerTitle = customerTitle || '';
    var $nameSection = $('.enquire-customer-firstname');
    if (!$nameSection.length) return;

    var $dropdown = $nameSection.find('.custom-drop-down-section');
    if (!$dropdown.length) return;

    var $options = $dropdown.find('.custom-option-value');
    if (!$options.length) return;

    var $display = $dropdown.find('.selected-value').first();
    var $hiddenInput = $nameSection.find('input[name="customerTitle"]');

    var $targetOption;

    // If customerTitle is passed → select matching option
    if (enquireFormCustomerTitle) {
        $targetOption = $options.filter(function () {
            var title = $(this).attr('data-title') || $(this).text().trim();
            return title === enquireFormCustomerTitle;
        }).first();
    }

    // If NOT passed or not found → select FIRST <li>
    if (!$targetOption || !$targetOption.length) {
        $targetOption = $options.first();
    }

    var nextTitle = $targetOption.attr('data-title') || $targetOption.text().trim();
    var nextCode = $targetOption.attr('data-code');

    // Reset selection
    $options.removeClass('selected');
    $targetOption.addClass('selected');

    // Update visible text
    if ($display.length) {
        $display.text(nextTitle);
    }

    // Update hidden field
    if ($hiddenInput.length && nextCode) {
        $hiddenInput.val(nextCode);
    }

    if (customerTitle) {
        $dropdown.addClass('non-editable');
    } else {
        $dropdown.removeClass('non-editable');
    }
}

/**
 * Resets the country code selection UI to a default value.
 *
 * @param {string} [countryCode=''] - Optional country code such as +91.
 */
function resetCountryCodeToDefault(countryCode) {
    var enquireFormCountryCode = countryCode || '';
    var $container = $('.enquire-customer-phone');
    var $defaultOption;

    // If countryCode is passed → use it
    if (enquireFormCountryCode) {
        $defaultOption = $container
            .find('.custom-option-value[data-id="' + enquireFormCountryCode + '"]')
            .first();
    } else { // Else → pick FIRST option from the list
        $defaultOption = $container.find('.custom-option-value').first();
    }

    if ($defaultOption.length) {
        var defaultCode = $defaultOption.data('id');

        // Update display
        $container.find('.selected-value, .country-selected-value')
            .text(defaultCode)
            .addClass('active');

        // Reset selected states
        $container.find('.custom-option-value, .country-option-item')
            .removeClass('selected');

        $defaultOption.addClass('selected');
        $container.addClass('selected');

        // Hide dropdown
        $container.find('.custom-option-values, .country-dropdown-options').hide();
    }

    if (countryCode) {
        $container.find('.custom-drop-down-section').addClass('non-editable');
    } else {
        $container.find('.custom-drop-down-section').removeClass('non-editable');
    }
}

/**
 * Restores the enquiry modal state each time the deferred modal is opened.
 */
function prepareEnquireModal() {
    var $form = getEnquireForm();

    if (!$form.length) {
        return;
    }

    $form[0].reset();
    $form.find('.is-invalid').removeClass('is-invalid');
    $form.find('.placeholder').removeClass('d-none');

    var isAuthenticated = $form.find('.isAuthenticated').val() === 'true';
    if (isAuthenticated) {
        $form.find('.pdp-enquiry-form-input').each(function () {
            var $input = $(this);
            if ($input.val().trim() !== '') {
                $input.siblings('.placeholder').addClass('d-none');
                $input.prop('readonly', true);
            }
        });

        var customerTitle = $form.find('.title-code').data('customertitle');
        var countryCode = $form.find('.mobile-dialing-code').val();
        if (customerTitle) resetCustomerTitle(customerTitle);
        if (countryCode) resetCountryCodeToDefault(countryCode);
    } else {
        $form.find('.pdp-enquiry-form-input').prop('readonly', false);
        $form.find('.first-name-input, .last-name-input, .input-mobile, .input-message').val('');
        resetCustomerTitle();
        resetCountryCodeToDefault();
    }

    var phoneLength = $form.find('.phone-input-field .custom-option-value.custom-option-login.selected').data('phonelength');
    $form.find('.input-mobile').attr('maxlength', phoneLength);
}

$(document).ready(function () {
    $('body').on('click', '#pdp-enquire-form .custom-drop-down-section .title-code-option', function () {
        var code = $(this).attr('data-code');
        var title = $(this).attr('data-title');
        $('#pdp-enquire-form .title-code').val(code);
        $('#pdp-enquire-form .title-code').attr('data-customertitle', title);
    });

    $('body').on('blur', '#pdp-enquire-form .pdp-enquiry-form-input', function () {
        var $input = $(this);
        var $form = getEnquireForm();

        if ($input.val().trim() === '') {
            $input.addClass('is-invalid');
            if ($input.hasClass('input-mobile')) {
                $form.find('.enquire-customer-phone .custom-drop-down-section').addClass('is-invalid');
            }

            if ($input.hasClass('first-name-input')) {
                addInvalidToTitle();
            }
        } else {
            $input.removeClass('is-invalid');
            if ($input.hasClass('input-mobile')) {
                validatePdpMobileInput();
            }
        }
    });

    $('body').on('input', '#pdp-enquire-form .pdp-enquiry-form-input', function () {
        var $input = $(this);
        var $form = getEnquireForm();

        if ($input.hasClass('first-name-input') || $input.hasClass('last-name-input')) {
            var nameVal = $input.val();

            // Prevent first space
            if (nameVal.startsWith(' ')) {
                $input.val('');
                $input.addClass('is-invalid');
                if ($input.hasClass('first-name-input')) {
                    addInvalidToTitle();
                }
                return;
            }

            // Allow only letters and spaces
            nameVal = nameVal.replace(/[^a-zA-Z\s]/g, '');

            // Prevent consecutive spaces
            if (/\s{2,}$/.test(nameVal)) {
                nameVal = nameVal.slice(0, -1);
            }

            $input.val(nameVal);
        }

        // Mobile input sanitization and restriction
        if ($input.hasClass('input-mobile')) {
            var sanitizedValue = $input.val().replace(/[^0-9+]/g, '');
            var selectedCode = $('.enquire-customer-phone .selected-value.active').text();
            // Prevent starting digits 0-5 only for +91
            if (selectedCode === '+91' && /^[0-5]/.test(sanitizedValue)) {
                $input.val('');
                validatePdpMobileInput();
                return;
            }
            $input.val(sanitizedValue);
        }

        // Message input sanitization
        if ($input.hasClass('input-message')) {
            var messageValue = $input.val();

            // Prevent first space
            if (messageValue.startsWith(' ')) {
                $input.val('');
                $input.addClass('is-invalid');
                return;
            }

            // Block more than one consecutive space
            if (/\s{2,}$/.test(messageValue)) {
                $input.val(messageValue.slice(0, -1));
                return;
            }
        }

        if ($input.val().trim() !== '') {
            $input.removeClass('is-invalid');

            if ($input.hasClass('input-mobile')) {
                $form.find('.enquire-customer-phone .custom-drop-down-section').removeClass('is-invalid');
            }

            if ($input.hasClass('first-name-input')) {
                removeInvalidFromTitle();
            }
        } else {
            $input.addClass('is-invalid');

            if ($input.hasClass('input-mobile')) {
                $form.find('.enquire-customer-phone .custom-drop-down-section').addClass('is-invalid');
            }

            if ($input.hasClass('first-name-input')) {
                addInvalidToTitle();
            }
        }
    });

    // Reset mobile on country change
    $('body').on('click', '#pdp-enquire-form .enquire-customer-phone .custom-option-value', function () {
        $('.input-mobile').val('');
        $('.input-mobile').removeClass('is-invalid').siblings('.placeholder').removeClass('d-none');
        $('.enquire-customer-phone').find('.custom-drop-down-section').removeClass('is-invalid');

        var phoneLength = $(this).data('phonelength');
        $('#pdp-enquire-form').find('#input-mobile').attr('maxlength', phoneLength);
    });

    // Updated phone input rule
    $('body').on('input', '#input-mobile', function () {
        var $this = $(this);
        var selectedCode = $('.enquire-customer-phone .selected-value.active').text();
        var val = $this.val().replace(/\D/g, '');
        var maxLength = $('.pdp-enquiry-form-input.input-mobile').attr('maxlength');

        // If +91 → don't allow starting digits 0–5
        if (selectedCode === '+91' && /^[0-5]/.test(val)) {
            val = val.replace(/^[0-5]+/, '');
        }

        // Limit to maxLength digits
        val = val.substring(0, maxLength);
        $this.val(val);
    });

    $('body').on('shown.bs.modal', '#productenquireform', function () {
        prepareEnquireModal();
    });

    $('body').on('hidden.bs.modal', '#productenquireform', function () {
        resetCustomerTitle();
        resetCountryCodeToDefault();
    });

    // Submit button validation
    $('body').on('click', '.pdp-enquiry-form-submit', function () {
        validateEnquireForm();
    });
});

module.exports = {
    handleEnquireFormModal: function () {
        $('body').on('click', '.close-pdp-enquiry-modal', function () {
            var $productEnquireForm = getProductEnquireFormModal();
            var $form = getEnquireForm();

            $productEnquireForm.modal('hide');
            $productEnquireForm.attr('aria-hidden', 'true');

            if ($form.length) {
                $form[0].reset();
                $form.find('.is-invalid').removeClass('is-invalid');
            }
        });
    },
    submitEnquireFormModal: function () {
        $('body').on('submit', '#pdp-enquire-form', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $productEnquireForm = getProductEnquireFormModal();
            var $customerSubmitResponse = getCustomerSubmitResponseModal();
            var $allReadyHaveResponse = getAllReadyHaveResponseModal();

            if (!validateEnquireForm()) {
                return;
            }
            var url = $this.data('url');
            var pid = $this.data('pid');
            var formData = $this.serialize() + '&pid=' + encodeURIComponent(pid) + '&countryCode=' + encodeURIComponent($this.find('#select-country-code').text()) + '&title=' + $this.find('.title-code').attr('data-customertitle');
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: formData,
                success: function (data) {
                    $.spinner().stop();
                    $productEnquireForm.modal('hide');
                    if (data.success === true) {
                        $customerSubmitResponse.modal();
                    } else {
                        $allReadyHaveResponse.modal();
                        setTimeout(function () {
                            $allReadyHaveResponse.modal('hide');
                        }, 5000);
                    }
                },
                error: function () {
                    $.spinner().stop();
                    $productEnquireForm.modal('hide');
                }
            });
        });
    }
};
